'use es6';

import { Iterable, Seq } from 'immutable';
import { valueSeq } from './TransmuteCollection';

var jsToValueSeq = function jsToValueSeq(subject) {
  return Seq(subject).valueSeq();
};

valueSeq.implement(Array, jsToValueSeq);
valueSeq.implementInherited(Iterable, function (subject) {
  return subject.valueSeq();
});
valueSeq.implement(Object, jsToValueSeq);
export default valueSeq;